import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => (
  {
    buttonProgress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    wrapper: {
      margin: theme.spacing(1),
      position: 'relative',
    },
  }
));

const KobooDialog = ({
  open,
  handleClose,
  dialogTitle,
  dialogText,
  handleCloseCancel,
  handleCloseOK,
  cancelText,
  okText,
  textField,
  disabled,
  loading,
}) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth={false}
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">
        {dialogTitle}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {dialogText}
        </DialogContentText>
        {textField}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseCancel} backgroundcolor="secondary" disabled={loading}>
          {cancelText}
        </Button>
        {okText &&
          <div className={classes.wrapper}>
            <Button onClick={handleCloseOK} color="primary" disabled={loading || disabled}>
              {okText}
            </Button>
            {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </div>
        }
      </DialogActions>
    </Dialog>
  );
};

export default KobooDialog;



// WEBPACK FOOTER //
// ./src/components/Layout/KobooDialog.jsx